import { render, staticRenderFns } from "./rekonsales.vue?vue&type=template&id=d795715a&scoped=true"
import script from "./rekonsales.vue?vue&type=script&lang=js"
export * from "./rekonsales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d795715a",
  null
  
)

export default component.exports